enum ACTIONS {
    DELETE_CONTACT = 'DELETE_CONTACT',
    UPDATE_CONTACT = '[CONTACT] - UPDATE',
    CREATE_CONTACT = 'CREATE_CONTACT',

    FETCH_CONTACT_CONCEPT = 'FETCH_CONTACT_CONCEPT',
    FETCH_ALL_CONTACTS = 'FETCH_ALL_CONTACTS_V2',
    FETCH_CONTACT = 'FETCH_CONTACT_V2',
    
    CREATE_CONTACT_VALUES = 'CREATE_CONTACT_VALUES',
    BACKGROUND_CREATE_CONTACT_VALUES = '[CONTACT][BACKGROUND] CREATE VALUES',
    UPDATE_CONTACT_VALUES = 'UPDATE_CONTACT_VALUES',
    UPSERT_CONTACT_VALUES = '[CONTACT] UPSERT VALUES',
    BACKGROUND_UPDATE_CONTACT_VALUES = '[CONTACT][BACKGROUND] UPDATE VALUES',
    
    FETCH_CONTACT_VALUES = 'FETCH_CONTACT_VALUES',
    FETCH_CONTACTS_VALUES = 'FETCH_CONTACTS_VALUES',

    FETCH_CONTACT_OVERVIEW_PAGE = '[CONTACT] Overview page'
}

export default ACTIONS;

export enum CREATE_CONTACT {
    REQUEST = 'CREATE_CONTACT_REQUEST',
    SUCCESS = 'CREATE_CONTACT_SUCCESS',
    FAILURE = 'CREATE_CONTACT_FAILURE'
}

export enum FETCH_ALL_CONTACT {
    REQUEST = 'FETCH_ALL_CONTACT_REQUEST',
    SUCCESS = 'FETCH_ALL_CONTACT_SUCCESS',
    FAILURE = 'FETCH_ALL_CONTACT_FAILURE'
}

export enum FETCH_CONTACT {
    REQUEST = 'FETCH_CONTACT_REQUEST',
    SUCCESS = 'FETCH_CONTACT_SUCCESS',
    FAILURE = 'FETCH_CONTACT_FAILURE'
}

export enum SAVE_CONTACT {
    REQUEST = 'SAVE_CONTACT_REQUEST',
    SUCCESS = 'SAVE_CONTACT_SUCCESS',
    FAILURE = 'SAVE_CONTACT_FAILURE'
}

export enum SAVE_CONTACT_STATUS {
    REQUEST = 'SAVE_CONTACT_STATUS_REQUEST',
    SUCCESS = 'SAVE_CONTACT_STATUS_SUCCESS',
    FAILURE = 'SAVE_CONTACT_STATUS_FAILURE'
}

export enum CONTACT {
    EDIT = 'CONTACT_EDIT',
    RESET = 'CONTACT_RESET'
}

export enum FETCH_CONTACT_DATASET {
    REQUEST = 'FETCH_CONTACT_DATASET_REQUEST',
    SUCCESS = 'FETCH_CONTACT_DATASET_SUCCESS',
    FAILURE = 'FETCH_CONTACT_DATASET_FAILURE'
}